import type { Middleware } from '@reduxjs/toolkit';
import { reduxWebsocket, WsPrefixes } from '@skynet/data-ws-core';

export const prefix = WsPrefixes.authPrefix;

const wsAuthMiddleware: Middleware = reduxWebsocket({
  prefix,
  reconnectOnClose: true,
  dateSerializer: (date: Date) => date.toISOString(),
});

export default wsAuthMiddleware;
